// Angular date format constants (using formatDate patterns)
export const DateFormats = {
    // ISO formats
    ISO_DATE: 'yyyy-MM-dd',                    // 2024-01-15
    ISO_DATETIME: 'yyyy-MM-ddTHH:mm:ss',       // 2024-01-15T14:30:00
    ISO_DATETIME_MS: 'yyyy-MM-ddTHH:mm:ss.SSS', // 2024-01-15T14:30:00.123

    // Belgian formats
    BELGIAN_DATE: 'dd/MM/yyyy',                // 15/01/2024
    BELGIAN_DATETIME: 'dd/MM/yyyy - HH:mm',    // 15/01/2024 - 14:30
    BELGIAN_DATETIME_FULL: 'dd/MM/yyyy HH:mm:ss', // 15/01/2024 14:30:00

    // Long formats
    LONG_DATE: 'd MMMM yyyy',                  // 15 januari 2024

    // Compact formats
    COMPACT_DATE: 'yyyyMMdd',                  // 20240115
    COMPACT_DATETIME: 'yyyyMMddHHmmss',        // 20240115143000
} as const;
